import _ from 'lodash'

import { createSelector } from 'reselect'
import {
  getInsuredFirstName,
  getInsuredLastName,
  getPayerNeeded,
  getBirthdateErrors,
  getTitleErrors,
  getPayerBirthdateErrors,
  getInsuredOccupationErrors,
  getPayerOccupationErrors,
  getPayerOtherOccupationErrors,
  getIsSelectedOtherOccupation,
  getInsuredOtherOccupationErrors,
  getIsSelectedPayerOtherOccupation,
  getIsOccupationsNotEmpty,
} from 'quick-quote/insured-information/selectors'
import { isQQFlow } from 'quick-quote/portal/selectors'
import { isAllowReviseQQMenu } from 'identity/selectors'
import { canProceedToInsuredInformation, getSelectedDisplayProduct } from 'quick-quote/product-selection/selectors'
import { getIsCompletedSuitabilityTested } from 'quick-quote/fna//suitability/selectors'
import { getAvailableRiders } from 'quick-quote/product-common/coverage-plan/selectors'
import VALUES from 'core/data-model/constants/values'
import { getToggles } from 'quick-quote/feature-toggles'

const getErrorsForCampaignProduct = createSelector(
  getBirthdateErrors,
  getPayerBirthdateErrors,
  getSelectedDisplayProduct,
  getAvailableRiders,
  (birthdateErrors, payerBirthdateErrors, selectedDisplayProduct, riders) => {
    const requiredRiderCodes = selectedDisplayProduct.requiredRiders || []
    const requiredRidersErrors = _(riders)
      .filter((rider) => requiredRiderCodes.includes(rider.code))
      .flatMap((rider) => {
        return rider.errors
      })
      .filter((error) => error.type === 'ELIGIBILITY')
      .value()

    return [...birthdateErrors, ...payerBirthdateErrors, ...requiredRidersErrors]
  }
)

const getOtherOccupationErrors = createSelector(
  getInsuredOtherOccupationErrors,
  getIsSelectedOtherOccupation,
  (insuredOtherOccupationErrors, isSelectedOtherOccupation) =>
    isSelectedOtherOccupation ? insuredOtherOccupationErrors : []
)

const getPayerOtherOccupationError = createSelector(
  getIsSelectedPayerOtherOccupation,
  getPayerOtherOccupationErrors,
  getSelectedDisplayProduct,
  (isSelectedPayerOtherOccupation, payerOtherOccupationErrors, selectedDisplayProduct) => {
    const payerOtherOccupationError =
      isSelectedPayerOtherOccupation && selectedDisplayProduct.category === VALUES.SAVING
        ? payerOtherOccupationErrors
        : []
    return payerOtherOccupationError
  }
)

export const canProceedToCoveragePlan = createSelector(
  getInsuredFirstName,
  getInsuredLastName,
  getPayerNeeded,
  getTitleErrors,
  getBirthdateErrors,
  getPayerBirthdateErrors,
  getInsuredOccupationErrors,
  getPayerOccupationErrors,
  getOtherOccupationErrors,
  getPayerOtherOccupationError,
  getErrorsForCampaignProduct,
  canProceedToInsuredInformation,
  getSelectedDisplayProduct,
  getIsOccupationsNotEmpty,
  isQQFlow,
  isAllowReviseQQMenu,
  getIsCompletedSuitabilityTested,
  (
    firstName,
    lastName,
    isPayerNeeded,
    titleErrors,
    birthdateErrors,
    payerBirthdateErrors,
    insuredOccupationErrors,
    payerOccupationErrors,
    otherOccupationErrors,
    payerOtherOccupationError,
    errorsForCampaignProduct,
    canProceedToInsuredInformation,
    selectedDisplayProduct,
    isOccupationNotEmpty,
    isQQFlow,
    isAllowReviseQQ,
    isCompletedSuitabilityTested
  ) => {
    const errors =
      selectedDisplayProduct.type === VALUES.CAMPAIGN_PRODUCT_TYPE
        ? [
            ...errorsForCampaignProduct,
            ...insuredOccupationErrors,
            ...titleErrors,
            ...otherOccupationErrors,
            ...(isPayerNeeded ? payerBirthdateErrors : []),
            ...(isPayerNeeded ? payerOccupationErrors : []),
            ...(isPayerNeeded ? payerOtherOccupationError : []),
          ]
        : [
            ...birthdateErrors,
            ...insuredOccupationErrors,
            ...titleErrors,
            ...otherOccupationErrors,
            ...(isPayerNeeded ? payerBirthdateErrors : []),
            ...(isPayerNeeded ? payerOccupationErrors : []),
            ...(isPayerNeeded ? payerOtherOccupationError : []),
          ]

    const canProceed =
      errors.length === 0 &&
      canProceedToInsuredInformation &&
      isCompletedSuitabilityTested &&
      (getToggles().ENABLE_OCCUPATION_BLANK ? isOccupationNotEmpty : true) &&
      (isQQFlow && isAllowReviseQQ ? true : !!firstName) &&
      (isQQFlow && isAllowReviseQQ ? true : !!lastName)
    return canProceed
  }
)
